import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

type NewsCardProps = {
  item: NewsItem;
  variant?: 'list' | 'grid';
};

export default function NewsCard({ item, variant = 'list' }: NewsCardProps) {
  if (variant === 'grid') {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      >
        <div className="h-40 w-full overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 资讯配图`}
            title={`${item.title} 电影资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4">
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
            {item.category}
          </span>
          <h3 className="mt-2 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {item.summary}
          </p>
          <p className="mt-3 flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-calendar-line" /> {item.date}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
    >
      <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
        <img
          src={item.cover}
          alt={`${item.title} 资讯配图`}
          title={`${item.title} 电影资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-500 md:text-sm">
          {item.summary}
        </p>
        <div className="mt-2 flex items-center gap-3 text-[11px] text-foreground-400">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" /> {item.date}
          </span>
        </div>
      </div>
    </Link>
  );
}